import { ApiProperty } from '@nestjs/swagger';

export class TagResponseDto {
    @ApiProperty({
        description: 'The unique identifier of the tag',
        example: 1
    })
    id: number;

    @ApiProperty({
        description: 'The title of the tag',
        example: 'company'
    })
    title: string;
}
